import { gql } from "@apollo/client"
import { SendMandateReminderInput, SendMandateReminderPayload } from "@oysterhr/schema"
import { InjectedOptions, useMutation } from "@oysterhr/core"

export const SEND_MANDATE_REMINDER = gql`
  mutation SendMandateReminder($mandateId: ID!) {
    sendMandateReminder(input: { mandateId: $mandateId }) {
      mandate {
        id
        state
      }
      errors
    }
  }
`

export const useResendMandate = (
  options?: InjectedOptions<
    {
      sendMandateReminder: SendMandateReminderPayload
    },
    SendMandateReminderInput
  >,
) => useMutation(SEND_MANDATE_REMINDER, options)
